export default __webpack_public_path__ + "images/slide_11.jpeg?874ce87f03ea8f2070460757944e030e";